import * as ActionTypes from '../../constants/ActionTypes';
import API from '../../helpers/api';

export function getRefereeInfo(id) {
	return async dispatch => {
		dispatch({
			type: ActionTypes.GET_REFEREE_INFO_REQUEST,
			payload: { loading: true }
		});

		const response = await API.referee_info.getRefereeInfo(id);

		if(response.meta.code !== 200) {
			dispatch({
				type: ActionTypes.GET_REFEREE_INFO_ERROR,
				payload: {
					meta: response.meta,
					loading: false
				}
			});
			return;
		}

		const { referee_info: refereeInfo } = response.data;

		dispatch({
			type: ActionTypes.GET_REFEREE_INFO_SUCCESS,
			payload: {
				refereeInfo,
				loading: false
			}
		});
	};
}

export function onRefereeInfoSubmit(fields) {
	return async dispatch => {
		dispatch({
			type: ActionTypes.SUBMIT_REFEREE_INFO_REQUEST,
			payload: { loadingSubmit: true }
		});
		
		const body = {
			referee_info: fields
		};
		
		let response;
		
		// Check if each object in the fields array has the id property
		const isBulkCreate = fields.every(field => !field.hasOwnProperty('id'));

		if (isBulkCreate) {
			response = await API.referee_info.createRefereeInfo(body);
		} else {
			response = await API.referee_info.updateRefereeInfo(body);
		}

		if(response.meta.code !== 200) {
			dispatch({
				type: ActionTypes.SUBMIT_REFEREE_INFO_ERROR,
				payload: {
					meta: response.meta,
					loadingSubmit: false
				}
			});
			return;
		}

		const { referee_info: newRefereeInfo } = response.data;

		dispatch({
			type: ActionTypes.SUBMIT_REFEREE_INFO_SUCCESS,
			payload: {
				refereeInfo: newRefereeInfo,
				loadingSubmit: false,
				meta: response.meta
			}
		});
	};
}

export function resetRefereeInfoPage() {
	return async dispatch => {
		dispatch({
			type: ActionTypes.RESET_REFEREE_INFO_PAGE
		});
	};
}

export function resetRefereeInfoMeta() {
	return async dispatch => {
		dispatch({
			type: ActionTypes.RESET_REFEREE_INFO_META
		});
	};
}